import {aSign} from './Asign';
import {bSign} from './Bsign';
import {cSign} from './Csign';
import {dSign} from './Dsign';
import {eSign} from './Esign';
import {fSign} from './Fsign';
import {gSign} from './Gsign';
import {hSign} from './Hsign';
import {iSign} from './Isign';
import {jSign} from './Jsign';
import {kSign} from './Ksign';
import {lSign} from './Lsign';
import {mSign} from './Msign';
import {nSign} from './Nsign';
import {oSign} from './Osign';
import {pSign} from './Psign';
import {qSign} from './Qsign';
import {rSign} from './Rsign';
import {sSign} from './Ssign';
import {tSign} from './Tsign';
import {uSign} from './Usign';
import {vSign} from './Vsign';
import {wSign} from './Wsign';
import {xSign} from './Xsign';
import {ySign} from './Ysign';
import {zSign} from './Zsign';



const Handsigns = {
    aSign,
    bSign,
    cSign,
    dSign,
    eSign,
    fSign,
    gSign,
    hSign,
    iSign,
    jSign,
    kSign,
    lSign,
    mSign,
    nSign,
    oSign,
    pSign,
    qSign,
    rSign,
    sSign,
    tSign,
    uSign,
    vSign,
    wSign,
    xSign,
    ySign,
    zSign,
}


export default Handsigns;